// extracted by mini-css-extract-plugin
module.exports = {"Error404Base":"Error404Base_n8Vxt","Error404Details":"Error404Details_iG7E4","Error404DetailsTitle":"Error404DetailsTitle_fBIg1"};